/**
 * @generated SignedSource<<52327aee43809bf5e90d7e767aca1a58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsStyleArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersCheckIsStyleArticle";
};
export type helpersCheckIsStyleArticle$key = {
  readonly " $data"?: helpersCheckIsStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsStyleArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsStyleArticle"
};

(node as any).hash = "9f847b0efb27a4bc0973bc672d96e1dd";

export default node;
